import { call, put, takeLatest, all } from "redux-saga/effects";
import axiosInstance from "utils/axiosInstance";
import { FETCH_MISSING_IMAGES } from "store/imageMap/actionTypes";

// Redux States
import {
  QUESTION_SET_FETCH_REQUEST,
  QUESTION_SET_FETCH_SUCCESS,
  QUESTION_SET_FETCH_FAILURE,
} from "./actionTypes"

function* fetchQuestionSetDetailsSaga(action) {
  console.log('running [fetchQuestionSetDetailsSaga]', action);
  const { topicId } = action;

  try {

    const [questionSetRes] = yield all([
      call(axiosInstance.get, `/knovia/myInfo/stores/${topicId}/getQuestionSetsInStoreTopic`)
    ]);

    const sortedQuestionSets = [...questionSetRes.data].sort((a, b) => a.order - b.order);

    yield put({
      type: QUESTION_SET_FETCH_SUCCESS,
      payload: sorted
    });

    // trigger image loading
    const qsImages = sorted.map(q => q.image).filter(Boolean);
    yield put({
      type: 'FETCH_MISSING_IMAGES',
      payload: { filenames: qsImages }
    });

  } catch (err) {
    console.error('[fetchQuestionSetDetailsSaga] Error:', err);
    yield put({
      type: 'QUESTION_SET_FETCH_FAILURE',
      error: err.message || 'Fetch failed'
    });
  }
}

function* questionSetDetailsSaga() {
  yield takeLatest(QUESTION_SET_FETCH_REQUEST, fetchQuestionSetDetailsSaga);
}

export default questionSetDetailsSaga;

